import {createApp} from 'vue'
import Store from 'store'
import ErrorGlobalModal from './ErrorGlobalModal'

const el = '.nlx-component--error-global-modal'
const DOM = document.querySelector(el)

if(DOM){

    const cartButtonProps = {
        titleLabel : DOM.dataset.titleLabel,
        buttonLabel : DOM.dataset.buttonLabel
    }

    const component = createApp(ErrorGlobalModal, {...cartButtonProps}).use(Store)

    component.mount(el)
}

